import { deepMerge } from '../internal/utils/deepMerge';
import { BASE_CONFIG } from './baseConfig';
import { STATIC_CONFIG } from './staticConfig';
import type {
  BorderRadiusConfig,
  CustomThemeConfig,
  ReeferTheme,
} from './theme.types';
import type { ColorConfig, ThemeColors } from './themeColors.types';
import type { ComponentsConfig } from './themeComponents.types';
import { calculateColorGroup } from './utils';

const generateColorGroups = (colorConfig: ColorConfig): ThemeColors => ({
  ...colorConfig,
  primary: calculateColorGroup(colorConfig.primary),
  secondary: calculateColorGroup(colorConfig.secondary),
  info: calculateColorGroup(colorConfig.info),
  success: calculateColorGroup(colorConfig.success),
  error: calculateColorGroup(colorConfig.error),
});

export const generateTheme = (
  customThemeConfig?: CustomThemeConfig
): ReeferTheme => {
  const baseConfig = JSON.parse(JSON.stringify(BASE_CONFIG));

  const borderRadius: BorderRadiusConfig = deepMerge(
    baseConfig.borderRadius,
    customThemeConfig?.borderRadius
  );

  const colors: ColorConfig = deepMerge(
    baseConfig.colors,
    customThemeConfig?.colors
  );

  const components: ComponentsConfig = deepMerge(
    baseConfig.components,
    customThemeConfig?.components
  );

  return {
    borderRadius,
    colors: {
      ...generateColorGroups(colors),
      ...STATIC_CONFIG.colors,
    },
    components,
  };
};
